/**
 * The foot of both sidebars: the release, for support, beside the user guide.
 *
 * @module components/shell/SidebarFooter
 */

import React from "react";

import { ExternalLinkButton, Text } from "@/components/ui";

import { USER_GUIDE_URL } from "./guide-links";

export function SidebarFooter({ version = undefined }: { version?: string }): React.ReactElement {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <ExternalLinkButton
        href={USER_GUIDE_URL}
        variant="ghost"
        icon="book-open-text"
        className="h-auto min-h-0 justify-start gap-2 px-0 font-normal text-muted hover:bg-transparent hover:text-base-content"
        data-testid="user-guide-link"
      >
        User guide
      </ExternalLinkButton>
      {version && (
        <Text size="sm" tone="muted">
          SocratIQ {version}
        </Text>
      )}
    </div>
  );
}
